import React from "react";
import styles from "./index.module.scss";
import { renderRichText } from "@/utils/formatters";
import { useRouter } from "next/router";
import { hideContentforLocale } from "@/utils/helper";

const InlineMediaBlock = ({ inlineMediaBlockData = {} }) => {
  const { locale } = useRouter();
  const {
    mainTitle,
    body = [],
    orientation,
    firstHeading = false,
    isAboutUs = false,
  } = inlineMediaBlockData;

  const renderHeading = heading => {
    return heading.split("®").flatMap((part, index, arr) =>
    index < arr.length - 1
    ? [part, <sup key={index}>®</sup>]
    : [part]
    );
  };

  const pairs = [];

  for (let i = 0; i < body.length; i++) {
    const item = body[i];
    const type = item?.sys?.contentType?.sys?.id;

    if (type === "imagesItem") {
      const nextItem = body[i + 1];
      if (nextItem?.sys?.contentType?.sys?.id === "contentItem") {
        pairs.push({
          image: item.fields,
          content: nextItem.fields,
        });
        i++;
      }
    } else if (type === "contentItem") {
      pairs.push({
        image: null,
        content: item.fields,
      });
    }
  }

  let mainTitleClass = firstHeading
    ? "koh-simple-content-first-title"
    : "koh-simple-content-title";

  return (
    <div className={styles.wrapper}>
      {mainTitle && (
        <section className="c-koh-simple-content v-koh-snippet">
          <div className="koh-simple-content-container">
            <h2 className={mainTitleClass}>{mainTitle}</h2>
          </div>
        </section>
      )}

      {pairs.map((pair, index) => {
        const { image, content } = pair;
        const imageUrl =
          image?.imageUrl || image?.assets?.[0]?.fields?.file?.url || null;
        const isImageLeft =
          pairs.length === 1 ? orientation !== "right" : index % 2 === 0;
        const isAboutUsTitleClass = isAboutUs
          ? "koh-simple-content-title-aboutus"
          : "koh-simple-content-title";
        const imageWidth = isAboutUs ? 240 : 400;
        const imageHeight = isAboutUs ? 175 : 290;
        const divClassName = isAboutUs ? "div-about-us" : "div-media-block";

        let showhideContent = hideContentforLocale(
          locale,
          content?.hideContentOn
        );
        const contentClass = showhideContent ? "hidden" : "";

        return (
          <>
            <section
              key={index}
              className={`${contentClass} c-koh-simple-content v-koh-snippet ${isAboutUs ? "line w-full" : ""}
              m-koh-wrap-content
              ${isImageLeft ? "m-koh-image-left" : "m-koh-image-right"}
              ${image?.imageUrl ? "" : "not-having-image"}
            `}
            >
              <div className={divClassName}>
                {imageUrl && (
                  <div className="koh-simple-content-image">
                    <img
                      src={imageUrl}
                      alt={image.alt || ""}
                      style={{
                        maxWidth: `${image.imageWidth || imageWidth}px`,
                        maxHeight: `${image.imageHeight || imageHeight}px`,
                      }}
                    />
                  </div>
                )}

                <div className="koh-simple-content-container">
                  {content.heading && (
                    <h2 className={isAboutUsTitleClass}>{renderHeading(content.heading)}</h2>
                  )}

                  <div className="koh-simple-content-body">
                    {renderRichText(content.description, locale)}
                  </div>
                </div>
              </div>
            </section>
          </>
        );
      })}
    </div>
  );
};

export default InlineMediaBlock;
